// Module
var code = "<div class=\"flex flex-container-row site-details\" ng-if=\"vm.currentTab === 'activity' && ('Security.Settings.SiteDetails.Activity' | webPermission: 'readOnly')\"> <div class=\"flex flex-container-row\" ng-include src=\"'configuration.html'\"/> </div>";
// Exports
module.exports = code;